import { render, staticRenderFns } from "./VerifyCode.vue?vue&type=template&id=2c4aea2d&"
import script from "./VerifyCode.vue?vue&type=script&lang=js&"
export * from "./VerifyCode.vue?vue&type=script&lang=js&"
import style0 from "./VerifyCode.vue?vue&type=style&index=0&id=2c4aea2d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports